import React from 'react';
import { Card, Text, Group, Title, Button, Divider, Progress, ActionIcon, Box } from '@mantine/core';
import { IconX, IconArrowLeft, IconArrowRight, IconCheck } from '@tabler/icons-react';
import styles from './TourTooltip.module.css';
import { TooltipRenderProps } from 'react-joyride';
import { useTranslation } from 'react-i18next';

const TourTooltip: React.FC<TooltipRenderProps> = ({
  step,
  index, 
  size, // total number of steps
  backProps, // props for back button
  closeProps, // props for close button
  primaryProps,// props for nextandfinish button
  skipProps, // props skip button
  isLastStep 
}) => {
    const { t } = useTranslation( 'tour' );
  const progress = (( index + 1 ) / size ) * 100;
  return (
    <Card 
      withBorder 
      radius="lg" 
      className={styles.tooltipCard}
      shadow="xl"
    >
      {/* Header with close button */}
      <Group justify="space-between" align="flex-start" className={styles.header}>
        <Box className={styles.titleSection}>
          {step.title && (
            <Title order={4} className={styles.title}>
              {step.title}
            </Title>
          )}
          <Text size="xs" c="dimmed" className={styles.stepCounter}>
             {t( 'step', 'Step' )} {index + 1} {t( 'of', 'of' )} {size}
          </Text>
        </Box>
        
        <ActionIcon
          variant="subtle"
          color="gray"
          size="sm"
          {...closeProps}
          className={styles.closeBtn}
        >
          <IconX size={16} />
        </ActionIcon>
      </Group>

      {/* Progress bar */}
      <Progress 
        value={progress} 
        size="xs" 
        radius="xl" 
        className={styles.progressBar}
        color="primary"
      />

      {/* Content */}
      <Box className={styles.content}>
        <Text size="sm" className={styles.contentText}>
          {step.content}
        </Text>
      </Box>

      {/* Footer with navigation */}
      <Group justify="space-between" align="center" className={styles.footer}>
        <Group gap="xs">
          {index > 0 && (
            <Button
              variant="subtle"
              size="sm"
              leftSection={<IconArrowLeft size={14} />}
              {...backProps}
              className={styles.backBtn}
            >
              {t( 'back_button', 'Back' )}
            </Button>
          )}
        </Group>

        <Group gap="xs">
          {!isLastStep && (
            <Button 
              variant="default" 
              size="sm" 
              {...skipProps}
              className={styles.skipBtn}
            >
              {t( 'skip_button', 'Skip' )}
            </Button>
          )}
          
          <Button
            variant="filled"
            size="sm"
            rightSection={
              isLastStep ? 
                <IconCheck size={14} /> : 
                <IconArrowRight size={14} />
            }
            {...primaryProps}
            className={styles.primaryBtn}
          >
            {isLastStep ? t( 'finish_button', 'Finish' ) : t( 'next_button', 'Next' )}
          </Button>
        </Group>
      </Group>
    </Card>
  );
};

export default TourTooltip;